window.ZAUN_SCHMUCKZAUN_DATEN = {
  farben: [
    "Anthrazit (RAL 7016)",
    "Grün (RAL 6005)",
    "Schwarz (RAL 9005)",
    "Feuerverzinkung"
  ],

  eingangspforte: [
    "ohne Eingangspforte",
    "1-flügelig",
    "2-flügelig"
  ],

  doppelfluegeltor: [
    "kein Doppelflügeltor",
    "3 m",
    "4 m",
    "5 m",
    "6 m"
  ],

  schiebetor: [
    "ohne Schiebetor",
    "manuell",
    "elektrisch"
  ],

  briefkasten: [
    "ohne Briefkasten",
    "mit Briefkasten"
  ],

  montage: [
    "ohne Montage",
    "mit Montage"
  ],

  reihen: {
    classic: {
      title: "Classic",
      image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-01.jpg?v=1776031959",
      modelle: [
        {
          id: "classic-aw-10-01",
          title: "CLASSIC AW.10.01",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-01.jpg?v=1776031959"
        },
        {
          id: "classic-aw-10-02",
          title: "CLASSIC AW.10.02",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-02.jpg?v=1776031977"
        },
        {
          id: "classic-aw-10-04",
          title: "CLASSIC AW.10.04",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-04.jpg?v=1776031983"
        },
        {
          id: "classic-aw-10-05",
          title: "CLASSIC AW.10.05",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-05.jpg?v=1776032074"
        },
        {
          id: "classic-aw-10-06",
          title: "CLASSIC AW.10.06",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-06.jpg?v=1776032079"
        },
        {
          id: "classic-aw-10-16",
          title: "CLASSIC AW.10.16",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-16.jpg?v=1776032084"
        },
        {
          id: "classic-aw-10-17",
          title: "CLASSIC AW.10.17",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-17.jpg?v=1776032088"
        },
        {
          id: "classic-aw-10-70",
          title: "CLASSIC AW.10.70",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-70.jpg?v=1776032103"
        },
        {
          id: "classic-aw-10-72",
          title: "CLASSIC AW.10.72",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-72.jpg?v=1776032113"
        },
        {
          id: "classic-aw-10-76",
          title: "CLASSIC AW.10.76",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-76.jpg?v=1776032117"
        },
        {
          id: "classic-aw-10-tt",
          title: "CLASSIC AW.10.TT",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/Zaunfeld-Classic-AW-10-TT.jpg?v=1776032129"
        }
      ]
    },

    home: {
      title: "Home",
      image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/zaunfeld-home-aw-10-200-paneel-250mm.jpg?v=1776032164",
      modelle: [
        {
          id: "home-01",
          title: "HOME 01",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/zaunfeld-home-aw-10-200-paneel-250mm.jpg?v=1776032164"
        },
        {
          id: "home-02",
          title: "HOME 02",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/zaunfeld-home-aw-10-200-paneel-500mm.jpg?v=1776032169"
        },
        {
          id: "home-03",
          title: "HOME 03",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/zaunfeld-home-aw-10-228-mit-abstand.jpg?v=1776032173"
        },
        {
          id: "home-04",
          title: "HOME 04",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/zaunfeld-home-aw-10-229.jpg?v=1776032186"
        }
      ]
    },

    lux: {
      title: "Lux",
      image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.31Wp.jpg?v=1776032198",
      modelle: [
        {
          id: "lux-01",
          title: "LUX 01 (AW.10.31)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.31Wp.jpg?v=1776032198"
        },
        {
          id: "lux-02",
          title: "LUX 02 (AW.10.33)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.58Wp.jpg?v=1776032253"
        },
        {
          id: "lux-03",
          title: "LUX 03 (AW.10.34)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.34P.jpg?v=1776032207"
        },
        {
          id: "lux-04",
          title: "LUX 04 (AW.10.39)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.39Wp.jpg?v=1776032212"
        },
        {
          id: "lux-05",
          title: "LUX 05 (AW.10.45)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.45Wp.jpg?v=1776032216"
        },
        {
          id: "lux-06",
          title: "LUX 06 (AW.10.46)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.46Wp.jpg?v=1776032220"
        },
        {
          id: "lux-07",
          title: "LUX 07 (AW.10.48)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.48Wp.jpg?v=1776032223"
        },
        {
          id: "lux-08",
          title: "LUX 08 (AW.10.51)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.51P.jpg?v=1776032227"
        },
        {
          id: "lux-09",
          title: "LUX 09 (AW.10.52)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.52P.jpg?v=1776032232"
        },
        {
          id: "lux-10",
          title: "LUX 10 (AW.10.53)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.53P.jpg?v=1776032235"
        },
        {
          id: "lux-11",
          title: "LUX 11 (AW.10.54)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.54P.jpg?v=1776032239"
        },
        {
          id: "lux-12",
          title: "LUX 12 (AW.10.56)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.56Wp.jpg?v=1776032243"
        },
        {
          id: "lux-13",
          title: "LUX 13 (AW.10.57)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.57Wp.jpg?v=1776032248"
        },
        {
          id: "lux-14",
          title: "LUX 14 (AW.10.58)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/LUX_AW.10.58Wp.jpg?v=1776032253"
        }
      ]
    },

    modern: {
      title: "Modern",
      image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-112.jpg?v=1776032324",
      modelle: [
        {
          id: "modern-aw-10-100",
          title: "MODERN AW.10.100",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-101.jpg?v=1776032286"
        },
        {
          id: "modern-aw-10-101",
          title: "MODERN AW.10.101",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-101.jpg?v=1776032286"
        },
        {
          id: "modern-aw-10-102",
          title: "MODERN AW.10.102",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-102.jpg?v=1776032289"
        },
        {
          id: "modern-aw-10-103",
          title: "MODERN AW.10.103",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-103.jpg?v=1776032292"
        },
        {
          id: "modern-aw-10-104",
          title: "MODERN AW.10.104",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-104.jpg?v=1776032295"
        },
        {
          id: "modern-aw-10-105",
          title: "MODERN AW.10.105",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-105.jpg?v=1776032298"
        },
        {
          id: "modern-aw-10-106",
          title: "MODERN AW.10.106",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-106.jpg?v=1776032302"
        },
        {
          id: "modern-aw-10-107",
          title: "MODERN AW.10.107",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-107.jpg?v=1776032306"
        },
        {
          id: "modern-aw-10-108",
          title: "MODERN AW.10.108",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-108.jpg?v=1776032309"
        },
        {
          id: "modern-aw-10-109",
          title: "MODERN AW.10.109",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-109.jpg?v=1776032313"
        },
        {
          id: "modern-aw-10-110",
          title: "MODERN AW.10.110",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-110.jpg?v=1776032316"
        },
        {
          id: "modern-aw-10-111",
          title: "MODERN AW.10.111",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-111.jpg?v=1776032321"
        },
        {
          id: "modern-aw-10-112",
          title: "MODERN AW.10.112",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-112.jpg?v=1776032324"
        },
        {
          id: "modern-aw-10-114",
          title: "MODERN AW.10.114",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-114_da0ccb73-ba55-462b-a153-b6a22ce26812.jpg?v=1776032332"
        },
        {
          id: "modern-aw-10-115",
          title: "MODERN AW.10.115",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/modern-zaunfeld-aw-10-115.jpg?v=1776032352"
        }
      ]
    },

    style: {
      title: "Style",
      image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/STYLE_AW.10.07P.jpg?v=1776032361",
      modelle: [
        {
          id: "style-01",
          title: "STYLE 01 (AW.10.07)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/STYLE_AW.10.07P.jpg?v=1776032361"
        },
        {
          id: "style-02",
          title: "STYLE 02 (AW.10.08)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/STYLE_AW.10.08P.jpg?v=1776032366"
        },
        {
          id: "style-03",
          title: "STYLE 03 (AW.10.09)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/STYLE_AW.10.09P.jpg?v=1776032368"
        },
        {
          id: "style-04",
          title: "STYLE 04 (AW.10.12)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/STYLE_AW.10.12P.jpg?v=1776032377"
        },
        {
          id: "style-05",
          title: "STYLE 05 (AW.10.14)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/STYLE_AW.10.14P.jpg?v=1776032382"
        },
        {
          id: "style-06",
          title: "STYLE 06 (AW.10.15)",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/STYLE_AW.10.15P.jpg?v=1776032385"
        }
      ]
    },

    vario: {
      title: "Vario",
      image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/VARIO_AW.10.81P.jpg?v=1776032420",
      modelle: [
        {
          id: "vario-01",
          title: "VARIO 01",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/VARIO_AW.10.81P.jpg?v=1776032420"
        },
        {
          id: "vario-02",
          title: "VARIO 02",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/VARIO_AW.10.82P.jpg?v=1776032423"
        },
        {
          id: "vario-03",
          title: "VARIO 03",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/VARIO_AW.10.83P.jpg?v=1776032427"
        },
        {
          id: "vario-04",
          title: "VARIO 04",
          image: "https://cdn.shopify.com/s/files/1/0867/0645/4859/files/VARIO_AW.10.84P.jpg?v=1776032431"
        }
      ]
    }
  }
};